import { collection, onSnapshot, query, where } from "firebase/firestore"
import { useEffect } from "react"
import { db } from "../firebase/config"
import useDoneOrders from "../store/SidebarNotifs/useDoneOrders"
import { useAuthContext } from "./useAuthContext"

const useFetchWarehouseOrders = () => {
  const { user } = useAuthContext()
  const { setDoneOrders, setLoading } = useDoneOrders()

  useEffect(() => {
    if (user) {
      setLoading(true)

      const ordersCollection = collection(db, "orders")
      const orderQ = query(
        ordersCollection,
        where("uid", "==", user.uid),
        where("orderStatus", "==", 6),
        where("hasInvoice", "==", true)
      )

      const unsubscribe = onSnapshot(orderQ, (snapshot) => {
        const doneOrders = snapshot.docs.map((doc) => ({
          id: doc.id, // include the document ID here
          ...doc.data(),
        }))
        setDoneOrders(doneOrders)
        setLoading(false)
      })

      return () => {
        unsubscribe()
      }
    }
  }, [setDoneOrders, setLoading, user])

  return {
    loading: useDoneOrders((state) => state.loading),
  }
}

export default useFetchWarehouseOrders
